module.exports = __webpack_public_path__ + "static/media/icon_journal_standard_selection.ab4748fa.svg";